import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { BodyText } from '../typography';

export const badgeType = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  warning: 'warning',
  danger: 'danger',
  success: 'success',
} as const;

export type BadgeType = keyof typeof badgeType;

export type BadgeProps = {
  label: string;
  type?: BadgeType;
  icon?: SvgComponent;
  iconOnClick?: () => void;
};

type WrapperProps = {
  color: string;
};

const Wrapper = styled(BodyText)<WrapperProps>`
  ${theme.typography.uiText.xs}
  display: flex;
  font-weight: 700;
  color: ${theme.colors.primary.white};
  background-color: ${({ color }) => color};
  padding: 2px 8px;
  width: fit-content;
  cursor: auto;

  svg {
    fill: ${theme.colors.primary.white};
    width: 24px;
    max-height: 27px;
    padding-left: 3px;
    cursor: pointer;
  }
`;

const badgeColor = (type: BadgeType) => {
  const { system, primary, neutrals, secondary } = theme.colors;
  switch (type) {
    case badgeType.success:
      return system.systemGreen;
    case badgeType.warning:
      return system.systemOrange;
    case badgeType.danger:
      return primary.graysRed;
    case badgeType.secondary:
      return neutrals.solidGrays[2];
    case badgeType.tertiary:
      return secondary.taupe;
    case badgeType.primary:
    default:
      return primary.graysBlue;
  }
};

export const Badge: React.FC<BadgeProps> = ({
  label,
  type = badgeType.primary,
  icon: Icon,
  iconOnClick,
  ...props
}) => {
  const handleOnClick = (e: MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    iconOnClick && iconOnClick();
  };
  return (
    <Wrapper color={badgeColor(type)} {...props}>
      {label} {Icon && <Icon onClick={handleOnClick} />}
    </Wrapper>
  );
};
